<div class="footer">
  <div class="logo">
    <div>r<span>.</span></div>
  </div>
  <div class="footer-content">
    <div id="twoElements">
      <a class="footer-element" href="mailto: info@rheto.ca">
        {{ "contactus" | transloco }}
      </a>
      <br />
      <a class="footer-element" [href]="doc"> {{ "policy" | transloco }}</a>
    </div>
    <div
      class="footer-element"
      (click)="changeLanguage()"
      style="margin-right: 10%"
    >
      {{ language }}
    </div>
  </div>
</div>
